class MeiliSearchConnector {
  constructor({ host, indexName }) {
    this.host = host
    this.indexName = indexName
  }

  async performSearch(searchTerm, searchOptions) {
    const params = new URLSearchParams({
      query: searchTerm,
      indexUid: this.indexName,
      ...searchOptions,
    })

    const response = await fetch(`${this.host}/v4/discovery/search?${params.toString()}`, {
      method: 'GET',
    })

    const jsonResponse = await response.json()
    if (jsonResponse.data) {
      const hits = jsonResponse.data.map(item => ({
        id: item.id,
        ...item.attributes,
      }))
      return {
        hits,
        estimatedTotalHits: jsonResponse.meta?.total || 0,
        limit: jsonResponse.meta?.limit || 20,
      }
    }
    return { hits: [], estimatedTotalHits: 0, limit: 20 }
  }

  async onSearch(state, queryConfig) {
    const { searchTerm, resultsPerPage, current } = state
    if (!searchTerm) {
      return {
        results: [],
        totalPages: 0,
        totalResults: 0,
      }
    }
    const { facets, ...rest } = queryConfig

    const searchParams = {
      ...rest,
      limit: resultsPerPage,
      offset: (current - 1) * resultsPerPage,
    }

    if (facets) {
      searchParams.facets = Object.keys(facets)
    }

    const response = await this.performSearch(searchTerm, searchParams)

    return {
      results: response.hits,
      totalPages: Math.ceil(response.estimatedTotalHits / resultsPerPage),
      totalResults: response.estimatedTotalHits,
    }
  }
}

export default MeiliSearchConnector
